import api from 'config/api.js';
import axios from 'axios';
import { getHeader, getAxiosUrl } from 'helpers';
import Cookies from 'js-cookie'
import { cookieName } from 'config';
const headers = getHeader();

export const signIn = async (loginData) => {
    try {
        const response = await axios.post(api.url + api.path.login, loginData, { headers });
        const { _token } = response.data;

        _token && Cookies.set(cookieName, _token, { expires: 14 })

        return {
            isLogged: !!_token,
            _token,
        };
    } catch (error) {
        Cookies.remove(cookieName);

        return {
            isLogged: false,
            user: null,
            error: error.response.data,
        };
    }
};

export const register = async (registerData) => {
    try {
        const response = await axios.post(api.url + api.path.register, registerData, { headers });
        return response.data;
    } catch (error) {
        return error.response.data;
    }
};

export const recoveryPassword = async (email) => {
    try {
        const response = await axios.post(api.url + api.path.forgotPassword, { email });
        return { ...response.data, email };
    } catch (error) {
        return error;
    }
};

export const setPassword = async (payload) => {
    try {
        // const url = getAxiosUrl(api.path.forgotPassword);
        const response = await axios.put(api.url + api.path.forgotPassword, payload);
        return response.data;
    } catch (error) {
        return error;
    }
};

export const signOut = async () => {
    try {
        const url = getAxiosUrl(api.path.logout);
        const response = await axios.get(url, { headers });
        const { status } = response;

        return status === 'ok';
    } catch (error) {
        return error;
    }
};
